/**
 * PagePreloaderHelper contains shortcut functions controlling behaviour of page preloader spinner
 */

import jQuery from 'jquery';
import MessageBusTopics from '../../common/MessageBusTopics';
import { isHomePage } from '../../utils';
import constant from '../constants/config';
import DeviceDetector from '../components/DeviceDetector';

/**
 * Function that publishes message that will show page preloader on whole page
 *
 * @returns {void}
 */
export const showPagePreloader = function() {
    window.WH.messageBus.publish(MessageBusTopics.PRELOADER_TOPIC, {
        operation: MessageBusTopics.PRELOADER_OPERATION_FULL_PAGE,
        data: true,
    });
};

/**
 * Function that publishes message that will hide page preloader
 *
 * @returns {void}
 */
export const hidePagePreloader = function() {
    window.WH.messageBus.publish(MessageBusTopics.PRELOADER_TOPIC, {
        operation: MessageBusTopics.PRELOADER_OPERATION_FULL_PAGE,
        data: false,
    });
};

export const preLoaderOverlayHTMLProperties = {
    querySelector: '#wh-global-overlay',
    toggleClass: 'wh-hide',
};

/**
 * Function is checking if initial overlay page preloader is visible or not and has two main functionalities
 *
 * Firstly, if it is visible, then we need to call showPagePreloader,
 * so PreLoaderManager can set inner counter to 1 and start controlling preloader behaviour.
 *
 * Secondly, if it is not visible, and we currently are on .com jurisdiction homepage on mobile device,
 * it means we want preloader on app starting and loading to be displayed with delay.
 *
 * @returns {number|undefined} timeoutID ID of timeout which is used to delay first page preloader (if there is any)
 */
export const initialisePagePreloader = function() {
    if (!jQuery(preLoaderOverlayHTMLProperties.querySelector).hasClass(preLoaderOverlayHTMLProperties.toggleClass)) {
        showPagePreloader();
        return;
    }

    if (window.whStatic.config.jurisdiction === '.com' && DeviceDetector.isMobile() && isHomePage()) {
        return setTimeout(showPagePreloader, constant.homepagePreloaderInitialDelay);
    }
};
